import { Link } from "react-router-dom";
import { Section } from "@/components/Section";
import { ArrowRight, BookOpen, Compass, Lightbulb } from "lucide-react";

// Insights is a placeholder for future thought-leadership articles, frameworks,
// and executive briefs. Nothing fabricated. The page communicates the intent
// and invites leaders to subscribe / book a consultation until content lands.

export default function Insights() {
  return (
    <div data-testid="page-insights">
      <Section
        eyebrow="Insights"
        title="Executive thinking on practical AI, leadership capacity, and the systems that carry your work."
        kicker="LAYOR is building a library of frameworks, executive briefs, and field-tested lessons from working with leaders. New pieces will be published here as they're finished, with no filler and no repurposed AI content."
      >
        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {[
            {
              icon: Compass,
              t: "Frameworks",
              b: "Practical decision frameworks for leaders evaluating where AI belongs in their organization, and where it does not.",
            },
            {
              icon: BookOpen,
              t: "Executive Briefs",
              b: "Decision-ready synthesis on the AI questions boards, cabinets, and executive teams are actually asking right now.",
            },
            {
              icon: Lightbulb,
              t: "Field Notes",
              b: "Short pieces on what's working, and what's not, in real leadership settings from LAYOR engagements.",
            },
          ].map(({ icon: Icon, t, b }, i) => (
            <div
              key={t}
              className="rounded-2xl border border-[var(--layor-border)] bg-white p-7"
              data-testid={`insights-category-${i}`}
            >
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--layor-navy)] text-[var(--layor-gold)]">
                <Icon size={20} />
              </div>
              <h3 className="mt-5 font-display text-xl text-[var(--layor-navy)] leading-snug">
                {t}
              </h3>
              <p className="mt-3 text-sm text-[var(--layor-muted)] leading-relaxed">{b}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 rounded-3xl border border-[var(--layor-border)] bg-[var(--layor-ivory)] p-8 md:p-10 text-center">
          <div className="text-[10px] uppercase tracking-[0.35em] font-semibold text-[var(--layor-pink)]">
            In Development
          </div>
          <h3 className="mt-4 font-display text-2xl md:text-3xl text-[var(--layor-navy)] leading-snug max-w-2xl mx-auto">
            The first Insights pieces are being written now.
          </h3>
          <p className="mt-4 text-[var(--layor-muted)] leading-relaxed max-w-xl mx-auto">
            In the meantime, book a consultation to get direct, unvarnished input on the specific
            AI and leadership questions your organization is working through.
          </p>
          <div className="mt-8 flex flex-wrap gap-3 justify-center">
            <Link
              to="/contact"
              className="btn-primary inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
            >
              Book a Consultation <ArrowRight size={14} />
            </Link>
            <Link
              to="/services"
              className="btn-ghost inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold"
            >
              Explore How We Help
            </Link>
          </div>
        </div>
      </Section>
    </div>
  );
}
